import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IOwnerList } from '../../../Pages/Owner/IOwner';

export const OwnerSlicer = createSlice({
  name: 'Owner',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IOwnerList[]>,
  reducers: {
    getOwner: (state) => {
      state.isLoading = true;
    },
    successGetOwner: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetOwner: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getOwner, successGetOwner, failureGetOwner } =
  OwnerSlicer.actions;

export default OwnerSlicer.reducer;
